import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_BASE_URL } from '../../../services/api';

export const fetchRooms = createAsyncThunk('rooms/fetchAll', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/rooms`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
  }
});

const initialState = { rooms: [], isLoading: false, error: null };
const roomSlice = createSlice({
  name: 'rooms',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchRooms.pending, (state) => { state.isLoading = true; })
      .addCase(fetchRooms.fulfilled, (state, action) => { state.isLoading = false; state.rooms = action.payload; })
      .addCase(fetchRooms.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
  },
});
export default roomSlice.reducer;